export default __webpack_public_path__ + "static/media/banner-login.788f2069.png";